import React, {Component} from 'react';
import { Route, Switch} from 'react-router-dom';
import Exemplo from '@/views/exemplo';
import ConsultaObras from '@/views/obras/ConsultaObras';
import DetalhamentoProcessoObra from '@/views/obras/DetalhamentoProcessoObra';
import Manutencao from '@/views/manutencao';

class Rotas extends Component{
    render(){
        return ( 
            <Switch>
                <Route exact path="/" component={Manutencao}/>
                <Route exact path="/manutencao" component={Manutencao}/>
                <Route exact path="/obras" component={ConsultaObras}/>
                <Route exact path="/obras/:orcamento" component={DetalhamentoProcessoObra}/>
                <Route path={"/exemplo"} component={Exemplo}/>
                <Route component={Manutencao}/>
            </Switch>
        )
    }
}

export default Rotas;  
